import React, { createContext, useContext, useState } from "react";

type UserInfo = {
  user_id: number;
  given_name: string;
  family_name: string;
  name: string;
  email: string;
  picture: string;
  appUserId?: number;
  photo?: string;
  manager?: object;
};

type AuthContextType = {
  userInfo: UserInfo | null;
  setUserInfo: (user: UserInfo | null) => void;
  isAuthenticated: boolean;
  isAuthLoading: boolean;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const isAuthenticated = !!userInfo;

  return (
    <AuthContext.Provider value={{ userInfo, setUserInfo, isAuthenticated, isAuthLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};
